/* eslint-disable @nx/enforce-module-boundaries */
import {
  Button,
  Checkbox,
  CheckboxGroup,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  PhoneNumberInput,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Select,
  Stack,
  Text,
} from '@mybridge/ui';
import { forwardRef, useContext } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { DateOfBirthInput } from 'v4/components/dob-input';
import { TagsInput } from 'v4/components/tags-input';
import { toPascalCase } from 'v4/lib/commons';
import { LANG_CHOICES, causesYouCare } from 'v4/lib/data';
import { MyProfileContext } from '../context';
import { LanguageDropdown } from 'v4/components/language-dropdown';
export const MyProfileUpdateModal = forwardRef(({ ...props }, ref) => {
  const {
    profileDisc,
    profileFieldErrors,
    profileUpdateLoading,
    updateProfile,
    userProfileInfo,
  } = useContext(MyProfileContext);

  const dob = userProfileInfo?.dob?.split('-') ?? [];
  const causes =
    userProfileInfo?.causes_you_care?.split(',').filter?.((v) => v.length) ??
    [];
  const interested_in =
    userProfileInfo?.interested_in?.split(',')?.filter?.((v) => v.length) ?? [];
  const profile = {
    ...(userProfileInfo ?? {}),
    dob: { day: dob[2], month: dob[1], year: dob[0] },
    causes_you_care: causes,
    interested_in,
  };

  const {
    register,
    handleSubmit,
    control,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: profile ?? {},
  });

  const onSubmit = async (form) => {
    delete form?.profile_banner_pic;
    // delete form?.profile_email;
    delete form?.profile_pic;
    const payload = {
      ...(form ?? {}),
      dob: form?.dob?.year + '-' + form?.dob?.month + '-' + form?.dob?.day,
      causes_you_care: form?.causes_you_care
        ?.filter((v) => v?.length)
        ?.join?.(','),
      interested_in: form?.interested_in?.filter((v) => v?.length)?.join?.(','),
      email:
        form?.profile_email && form?.profile_email !== 'null'
          ? form?.profile_email
          : '',
    };
    updateProfile(payload);
  };

  return (
    <Modal size="xl" {...(profileDisc ?? {})}>
      <ModalOverlay />
      <ModalContent>
        <form onSubmit={handleSubmit(onSubmit)}>
          <ModalHeader>
            Profile
            <ModalCloseButton />
          </ModalHeader>
          <ModalBody>
            <Stack spacing={4}>
              <FormControl
                isInvalid={profileFieldErrors?.email?.length}
              >
                <FormLabel>Email</FormLabel>
                <Input
                  // isDisabled={true}
                  type="email"
                  {...register('email')}
                  placeholder="Email"
                />
                {profileFieldErrors?.email?.map((e, eIndex) => (
                  <FormErrorMessage key={eIndex}>{e}</FormErrorMessage>
                ))}
              </FormControl>
              <FormControl isInvalid={errors?.mobile_number}>
                <FormLabel>Mobile No.</FormLabel>
                {/* <Input
                  type="phone"
                  {...register('mobile_number')}
                  placeholder="eg. 9876543210"
                /> */}
                <Controller
                  render={({ field }) => (
                    <PhoneNumberInput
                      // {...register('mobile_number')}
                      {...field}
                      placeholder="eg. 9876543210"
                    />
                  )}
                  name="mobile_number"
                  control={control}
                  rules={{
                    maxLength:15,
                    required:false,
                    validate(val) {
                      if (val && val.length) {
                        const arr = val?.split('-');
                        return arr.length > 1 && arr?.[0]?.length > 0;
                      } else {
                        return true;
                      }
                    },
                  }}
                />
                <FormErrorMessage>Please enter a valid mobile number</FormErrorMessage>
              </FormControl>
              <FormControl isInvalid={errors?.lang}>
                <FormLabel>Language</FormLabel>
                {/* <Select {...register('lang')}>
                  {LANG_CHOICES.map((lc, lcIndex) => (
                    <option key={lcIndex} value={lc?.value}>
                      {lc.label}
                    </option>
                  ))}
                </Select> */}
                <Controller
                  render={({ field }) => (
                    <TagsInput title="Languages" {...field}>
                      {({ addTag, setEdit }) => (
                        <LanguageDropdown
                          allowCreate
                          onChange={(obj) => {
                            addTag?.(obj?.name);
                            setEdit(false);
                          }}
                        >
                          {(input) => (
                            <Input
                              {...(input ?? {})}
                              borderRadius="full"
                              onClick={(e) => input?.disc?.onOpen?.()}
                              onChange={(e) => input?.onChange(e.target.value)}
                              placeholder="Type to search..."
                              onKeyUp={(e) => {
                                input?.onKeyUp?.(e);
                                if (e.keyCode === 27) {
                                  setEdit(false);
                                }
                              }}
                              autoFocus
                            />
                          )}
                        </LanguageDropdown>
                      )}
                    </TagsInput>
                  )}
                  name="language"
                  control={control}
                />
                <FormErrorMessage>Mobile no is required</FormErrorMessage>
              </FormControl>
              <FormControl isInvalid={errors?.dob}>
                <FormLabel>Date of birth</FormLabel>
                <Controller
                  render={({ field }) => <DateOfBirthInput {...field} />}
                  name="dob"
                  // rules={{ required: true }}
                  control={control}
                />
                <FormErrorMessage>Date of birth is required</FormErrorMessage>
              </FormControl>
              <FormControl isInvalid={errors?.interested_in}>
                <FormLabel>Interests</FormLabel>
                <Controller
                  render={({ field }) => <TagsInput {...field} />}
                  name="interested_in"
                  control={control}
                />
              </FormControl>
              <FormControl isInvalid={errors?.causes_you_care}>
                <FormLabel>Causes you care about</FormLabel>
                <Controller
                  render={({ field }) => (
                    <CheckboxGroup {...field}>
                      <Stack>
                        {causesYouCare.map((cyc, cycIndex) => (
                          <Checkbox key={cycIndex} value={cyc}>{toPascalCase(cyc)}</Checkbox>
                        ))}
                      </Stack>
                    </CheckboxGroup>
                  )}
                  control={control}
                  name="causes_you_care"
                />
              </FormControl>
            </Stack>
          </ModalBody>
          <ModalFooter>
            <HStack>
              <Button
                onClick={(e) => profileDisc?.onClose?.()}
                variant="secondary"
              >
                Cancel
              </Button>
              <Button
                isLoading={profileUpdateLoading}
                type="submit"
                variant="primary"
              >
                Save
              </Button>
            </HStack>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  );
});
